/**
 * /blog · Cyannect blog index (lightweight, no CMS).
 *
 * Adding a post = create a new file under `pages/blog/posts/` and register
 * it in the POSTS array below. Kept intentionally simple so marketing can
 * ship a launch post without a full headless-CMS integration.
 */
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

const POSTS = [
  {
    slug: "introducing-starter-and-growth",
    title:
      "Introducing Cyannect Starter and Growth: performance commerce for Canadian merchants",
    excerpt:
      "Two plans, per-storefront province coverage, and a flat 15% discount when you pay annually — Cyannect is now open to Canadian merchants.",
    date: "2026-02-01",
    tag: "Product launch",
  },
];

export default function Blog() {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-white">
      <Seo
        title="Cyannect Blog"
        description="Cyannect news, product updates and merchant playbooks for Canadian performance commerce."
        path="/blog"
      />
      <div className="max-w-3xl mx-auto px-6 py-16" data-testid="blog-index">
        <h1 className="font-display text-4xl font-medium text-slate-900">Cyannect Blog</h1>
        <p className="text-slate-600 mt-2">
          Product updates, launch news and merchant playbooks.
        </p>
        <div className="mt-10 space-y-6">
          {POSTS.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="block pf-card p-6 hover:border-burgundy-300 transition-all"
              data-testid={`blog-card-${post.slug}`}
            >
              <div className="flex items-center gap-3 text-xs text-slate-500 mb-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-cream-50 border border-cream-200 px-2 py-0.5 text-burgundy-800 font-semibold uppercase tracking-widest">
                  {post.tag}
                </span>
                <span className="inline-flex items-center gap-1">
                  <Calendar className="w-3.5 h-3.5" />
                  {new Date(post.date).toLocaleDateString("en-CA", {
                    year: "numeric", month: "long", day: "numeric",
                  })}
                </span>
              </div>
              <h2 className="font-display text-2xl font-semibold text-slate-900">
                {post.title}
              </h2>
              <p className="text-slate-600 mt-2">{post.excerpt}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-burgundy-700">
                Read post <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
